module.exports = __webpack_public_path__ + "static/media/audio-fatwas.d379573c.webp";